import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import ModuleListPage from "../../Sections/KnowledgeBase/ModuleListPage"

const ModuleListComponent = () => {
  return <Dashboard sectionName={<ModuleListPage />} />;
};

export default ModuleListComponent;
